import { render, staticRenderFns } from "./outsource-case-info.vue?vue&type=template&id=158a10bc&scoped=true"
import script from "./outsource-case-info.vue?vue&type=script&lang=ts"
export * from "./outsource-case-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a10bc",
  null
  
)

export default component.exports